import React from "react";
import {
  Page,
  Layout,
  Card,
  SkeletonBodyText,
  SkeletonDisplayText,
  FormLayout,
} from "@shopify/polaris";

function SkeletonSection({ descriptionLines, cardLines }) {
  return (
    <Layout.AnnotatedSection
      title={<SkeletonDisplayText />}
      description={<SkeletonBodyText lines={descriptionLines} />}
    >
      <Card sectioned>
        <FormLayout>
          {Array.from({ length: cardLines }, (_, i) => (
            <SkeletonBodyText lines={2} key={i} />
          ))}
        </FormLayout>
      </Card>
    </Layout.AnnotatedSection>
  );
}

export default function ThemeLanguageSkeleton(props) {
  return (
    <Page>
      <Layout>
        <SkeletonSection key={1} descriptionLines={2} cardLines={2} />
        <SkeletonSection key={2} descriptionLines={3} cardLines={4} />
        <SkeletonSection key={3} descriptionLines={2} cardLines={2} />
        <SkeletonSection key={4} descriptionLines={1} cardLines={3} />
      </Layout>
    </Page>
  );
}
